import PropTypes from "prop-types";
import { useMemo } from "react";
// @mui
import { CssBaseline, responsiveFontSizes } from "@mui/material";
import {
  ThemeProvider as MUIThemeProvider,
  createTheme,
  StyledEngineProvider,
} from "@mui/material/styles";
//
import palette from "./palette";
import typography from "./typography";
import GlobalStyles from "./globalStyles";

// ----------------------------------------------------------------------

const ThemeProvider = (props) => {
  const { children } = props;

  const themeOptions = useMemo(
    () => ({
      palette,
      shape: { borderRadius: 6 },
      typography,
    }),
    []
  );

  const theme = createTheme(themeOptions);
  theme.components = {
    MuiCssBaseline: {
      styleOverrides: `
        input:-webkit-autofill,
        input:-webkit-autofill:hover,
        input:-webkit-autofill:focus,
        textarea:-webkit-autofill,
        textarea:-webkit-autofill:hover,
        textarea:-webkit-autofill:focus,
        select:-webkit-autofill,
        select:-webkit-autofill:hover,
        select:-webkit-autofill:focus {
          -webkit-text-fill-color: #FFFFFF;
          -webkit-box-shadow: 0 0 0px 1000px transparent inset;
          transition: background-color 5000s ease-in-out 0s;
        }
      `,
    },

    MuiButton: {
      styleOverrides: {
        root: {
          boxShadow: "none",
          borderRadius: "12px",
          padding: "10px 18px",
        },
        startIcon: {
          [theme.breakpoints.down("md")]: {
            margin: "0",
          },
        },
      },
    },
    MuiListItemAvatar: {
      styleOverrides: {
        root: {
          minWidth: "45px",
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        primary: {
          [theme.breakpoints.up("lg")]: {
            fontSize: "24px",
          },
          [theme.breakpoints.down("lg")]: {
            fontSize: "22px",
          },
          [theme.breakpoints.down("md")]: {
            fontSize: "18px",
          },
          fontWeight: 600,
          color: "black",
        },
        secondary: {
          [theme.breakpoints.up("lg")]: {
            fontSize: "18px",
          },
          [theme.breakpoints.down("lg")]: {
            fontSize: "16px",
          },
          fontWeight: 300,
          color: "black",
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          minWidth: "30px",
        },
      },
    },
    MuiAvatar: {
      styleOverrides: {
        root: {
          fontSize: "14px",
          fontWeight: 700,
          width: "30px",
          height: "30px",
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          zIndex: 1000,
        },
      },
    },
  };

  return (
    <StyledEngineProvider injectFirst>
      <MUIThemeProvider theme={responsiveFontSizes(theme)}>
        <CssBaseline />
        <GlobalStyles />
        {children}
      </MUIThemeProvider>
    </StyledEngineProvider>
  );
};

ThemeProvider.propTypes = {
  children: PropTypes.node,
};

export default ThemeProvider;
